import React from "react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {numberFormat} from "@pg-mono/string-utils";

import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {Country} from "../../../region/types/Country";
import {getCurrency} from "../../../utils/get_currency";
import {InquiryButtonTypeName} from "../../detail/constants/inquiry_button_type";
import {IOfferDetail} from "../../types/IOfferDetail";
import {OfferPriceType} from "../../types/OfferPriceType";
import {getOfferDisplayStatus} from "../../utils/get_offer_display_status";

interface IProps {
    offer: IOfferDetail;
}

export function OfferDetailHeaderPriceButton(props: IProps) {
    const {offer} = props;

    const offerRangePrice = (offer.region.country === Country.SPAIN && offer?.stats?.ranges_price_min) || offer.stats?.ranges_price_m2_min || null;
    const priceType = offer.price_type === OfferPriceType.NETTO ? " netto" : offer.price_type === OfferPriceType.BRUTTO ? " brutto" : "";

    return (
        <>
            {offerRangePrice ? (
                <ApplicationModalButton
                    source={ApplicationSource.OfferPriceInquiry}
                    sourceSection={ApplicationSourceSection.HEADER}
                    vendorId={offer.vendor.id}
                    offerId={offer.id}
                    propertyId={null}
                    forceClose={getOfferDisplayStatus(offer) === "limited"}
                    render={({openModal}) => (
                        <Button onClick={openModal} variant="outlined_secondary" size="medium" css={[w100]} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            Ceny od:{" "}
                            <span className="bt">
                                {`${numberFormat(offerRangePrice)} ${getCurrency({currency: offer.currency})}${priceType}`}
                                {offer.region.country === Country.SPAIN && offer.stats?.ranges_price_min ? null : (
                                    <>
                                        /m<sup>2</sup>
                                    </>
                                )}
                            </span>
                        </Button>
                    )}
                />
            ) : (
                <ApplicationModalButton
                    source={ApplicationSource.OfferPriceInquiry}
                    sourceSection={ApplicationSourceSection.HEADER}
                    vendorId={offer.vendor.id}
                    offerId={offer.id}
                    propertyId={null}
                    forceClose={getOfferDisplayStatus(offer) === "limited"}
                    render={({openModal}) => (
                        <Button onClick={openModal} variant="outlined_secondary" css={[w100]} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            {InquiryButtonTypeName.PRICES}
                        </Button>
                    )}
                />
            )}
        </>
    );
}
import React from "react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {numberFormat} from "@pg-mono/string-utils";

import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {Country} from "../../../region/types/Country";
import {getCurrency} from "../../../utils/get_currency";
import {InquiryButtonTypeName} from "../../detail/constants/inquiry_button_type";
import {IOfferDetail} from "../../types/IOfferDetail";
import {OfferPriceType} from "../../types/OfferPriceType";
import {getOfferDisplayStatus} from "../../utils/get_offer_display_status";

interface IProps {
    offer: IOfferDetail;
}

export function OfferDetailHeaderPriceButton(props: IProps) {
    const {offer} = props;

    const offerRangePrice = (offer.region.country === Country.SPAIN && offer?.stats?.ranges_price_min) || offer.stats?.ranges_price_m2_min || null;
    const priceType = offer.price_type === OfferPriceType.NETTO ? " netto" : offer.price_type === OfferPriceType.BRUTTO ? " brutto" : "";

    return (
        <>
            {offerRangePrice ? (
                <ApplicationModalButton
                    source={ApplicationSource.OfferPriceInquiry}
                    sourceSection={ApplicationSourceSection.HEADER}
                    vendorId={offer.vendor.id}
                    offerId={offer.id}
                    propertyId={null}
                    forceClose={getOfferDisplayStatus(offer) === "limited"}
                    render={({openModal}) => (
                        <Button onClick={openModal} variant="outlined_secondary" size="medium" css={[w100]} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            Ceny od:{" "}
                            <span className="bt">
                                {`${numberFormat(offerRangePrice)} ${getCurrency({currency: offer.currency})}${priceType}`}
                                {offer.region.country === Country.SPAIN && offer.stats?.ranges_price_min ? null : (
                                    <>
                                        /m<sup>2</sup>
                                    </>
                                )}
                            </span>
                        </Button>
                    )}
                />
            ) : (
                <ApplicationModalButton
                    source={ApplicationSource.OfferPriceInquiry}
                    sourceSection={ApplicationSourceSection.HEADER}
                    vendorId={offer.vendor.id}
                    offerId={offer.id}
                    propertyId={null}
                    forceClose={getOfferDisplayStatus(offer) === "limited"}
                    render={({openModal}) => (
                        <Button onClick={openModal} variant="outlined_secondary" css={[w100]} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            {InquiryButtonTypeName.PRICES}
                        </Button>
                    )}
                />
            )}
        </>
    );
}
